module.exports = __webpack_public_path__ + "static/media/castle.1c5c04e2.svg";